// components/EditorialCard.tsx
import { Box, CSS, Icon, Text } from '@qcx/ui';
import { FollowButton } from './FollowButton';
import { Link } from '../../../components/Link';
import { faFileCheck } from '@fortawesome/pro-regular-svg-icons';
import { route } from '../../../route';
import type { Editorial } from '@atreus/data';

interface EditorialCardProps {
  editorial: Editorial;
  css?: CSS;
}

export const EditorialCard = ({ editorial, css }: EditorialCardProps) => {
  return (
    <Box
      css={{
        d: 'flex',
        gap: '$4',
        px: '$4',
        py: '$4',
        borderRadius: '$4xl',
        w: '$full',
        border: '1px solid $neutral200',
        justifyContent: 'space-between',
        '&:hover': {
          bgColor: '$hoverBg'
        },
        ...css
      }}
    >
      <Link
        css={{
          display: 'flex',
          w: '$full',
          alignContent: 'center'
        }}
        to={route('editorials-show', {
          slug: editorial.slug
        })}
      >
        <Box
          css={{
            d: 'flex',
            alignItems: 'center',
            gap: '$4'
          }}
        >
          <Box
            css={{
              minMaxSize: '$9',
              borderRadius: '$full',
              bg: '$blue50',
              flexCenter: true
            }}
          >
            <Icon icon={faFileCheck} size={'lg'} />
          </Box>
          <Text
            css={{ color: '$text' }}
            variant={{
              '@initial': 'md',
              '@md': 'lg'
            }}
            weight="semibold"
          >
            {editorial.name}
          </Text>
        </Box>
      </Link>
      {editorial.id && editorial.kindText === 'Instituto' && (
        <FollowButton editorialId={editorial.id} />
      )}
    </Box>
  );
};
